import { TabContext, TabList, TabPanel } from "@mui/lab";
import { Box, Tab } from "@mui/material";
import type React from "react";
import { useTypedQueryParams } from "../hooks/use-query-params.ts";
import TestSuitesPage from "./test-suites";
import TestsPage from "./tests";

interface TestsMainTabs {
  tab?: "tests" | "test-suites";
}

export default function TestsMainPage() {
  const { params, setParam } = useTypedQueryParams<TestsMainTabs>();
  const tab = params.tab ?? "tests";

  const handleChange = (_: React.SyntheticEvent, newValue: string) => {
    setParam("tab", newValue as TestsMainTabs["tab"]);
  };

  return (
    <Box data-testid="tests-main-page">
      <TabContext value={tab}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <TabList onChange={handleChange} aria-label="Test details tabs">
            <Tab label="Tests" value="tests" />
            <Tab label="Suites" value="test-suites" />
          </TabList>
        </Box>
        <TabPanel value="tests">
          <TestsPage />
        </TabPanel>
        <TabPanel value="test-suites">
          <TestSuitesPage />
        </TabPanel>
      </TabContext>
    </Box>
  );
}
